import { formatPrice, formatTitle, useProductName } from "@/utils";
import {
  Badge,
  Box,
  Center,
  Flex,
  FlexProps,
  Image,
  Spinner,
  Text
} from "@chakra-ui/react";

import { CouponObject, ItemObject, ShippingObject } from "@/types";

import { v4 as uuidv4 } from "uuid";
type PartnerProps = {
  name?: string;
  street?: string;
  number?: string;
  cep?: string;
  city?: string;
  district?: string;
  phone1?: string;
  phone2?: string;
  cellphone?: string;
};

type PartnerData = {
  partnerRequest: (id: string) => any;
};

interface ResumeCartProps extends FlexProps {
  Items: ItemObject[];
  Shipping: ShippingObject[];
  Coupon: CouponObject;
  SubTotal: string;
  Total: number;
}

export function ResumeCart({
  Items,
  Shipping,
  Coupon,
  SubTotal,
  Total,
  ...rest
}: ResumeCartProps) {
  const IMGPATH = process.env.NEXT_PUBLIC_IMAGE_PATH;
  const Shipp = Shipping?.filter((shipp) => shipp.default)[0];
  const CoupunValue = () => {
    const Sub = parseFloat(
      SubTotal.replaceAll(".", "")
        .replaceAll("R$", "")
        .replaceAll(",", ".")
        .replaceAll(" ", "")
    );

    return Sub * (Coupon?.discount / 100);
  };
  return (
    <Flex
      {...rest}
      bgColor="#F9F9F9"
      flex={1}
      border={"1px solid"}
      borderLeftColor="gray.300"
      borderLeftWidth="1px"
      borderLeftStyle="solid"
    >
      {Items ? (
        <Flex pt="20px" pl="20px" direction="column">
          <Text fontSize="h2" fontWeight="bold">
            Resumo
          </Text>
          {Items?.map((item, index) => (
            <Flex
              mb={"3"}
              key={uuidv4()}
              borderBottom={"2px solid"}
              borderBottomColor={"gray.300"}
              p={0}
            >
              <Flex width={"60px"} height={"full"} position={"relative"}>
                <Badge
                  position={"absolute"}
                  bgColor={"red"}
                  color={"white"}
                  borderRadius={"full"}
                  right={"1"}
                >
                  {item.qty}
                </Badge>
                <Image
                  src={`${IMGPATH}${item.urlImagemProduto}`}
                  alt={item.name}
                  width={"60px"}
                  height={"full"}
                />
              </Flex>

              <Flex
                direction={"column"}
                alignItems={"flex-start"}
                justifyContent={"start"}
              >
                <Text fontWeight={"bold"} fontSize={"14px"}>
                  {formatTitle(item.name)}
                </Text>
                <Text fontWeight={"bold"} fontSize={"14px"}>
                  {useProductName(item.name)[1]
                    .split(" ")
                    .splice(-3, 2)
                    .join(" ")}
                </Text>
                <Text fontWeight={"bold"} color={"blue.500"} fontSize={"14px"}>
                  {useProductName(item.name)[0]}
                </Text>
              </Flex>

              <Flex
                direction={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                ml={"auto"}
              >
                <Text
                  textAlign={"center"}
                  fontWeight={"regular"}
                  color={"blue.500"}
                >
                  {formatPrice(item.prices[0].value)}
                </Text>
              </Flex>
            </Flex>
          ))}

          <Flex direction="column" alignItems="flex-end" mt="20px">
            <Flex mb="20px" direction="column" width="250px">
              <Flex justifyContent={"space-between"}>
                <Text fontWeight={"semibold"}>Subtotal</Text>
                <Text fontWeight={"semibold"}>{SubTotal}</Text>
              </Flex>

              {Coupon && (
                <Flex justifyContent={"space-between"}>
                  <Text fontWeight={"semibold"} color={"green.300"}>
                    {Coupon.couponDesc}
                  </Text>
                  <Text fontWeight={"semibold"} color="green.300">
                    - {formatPrice(CoupunValue())}
                  </Text>
                </Flex>
              )}

              <Flex justifyContent={"space-between"}>
                <Text fontWeight={"semibold"} color={"gray.600"}>
                  Frete {Shipp?.type}
                </Text>
                <Text fontWeight={"semibold"} color={"gray.600"}>
                  {formatPrice(Shipp?.value)}
                </Text>
              </Flex>

              <Flex justifyContent={"space-between"}>
                <Text fontWeight={"semibold"}>Total</Text>
                <Text fontWeight={"semibold"}>{Total}</Text>
              </Flex>

              <Flex direction="column" width="100%" mt="5px">
                <Text fontSize="text3" color="blue.900" alignItems="right">
                  Prazo de entrega: 3 a 4 dias úteis
                </Text>
                <Text fontSize="text3" color="blue.900" alignItems="right">
                  (após confirmação de pagamento)
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      ) : (
        <Center>
          <Box>
            <Spinner size="xl" color="#1e1e1e" />
          </Box>
        </Center>
      )}
    </Flex>
  );
}

// TODO: include interface for cartItems Promise
